/* main.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02oEu0%7Bwidth%3Avar(--link-picker-width)%7D");
import React, { memo } from 'react';
// oxlint-disable-next-line @atlassian/no-restricted-imports
import { LazySuspense } from 'react-loosely-lazy';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { COMPONENT_NAME, LINK_PICKER_WIDTH_IN_PX } from '../common/constants';
import type { LinkPickerProps } from '../common/types';
import type { PackageMetaDataType } from '../common/utils/analytics/analytics.codegen';
import { LinkPickerSessionProvider } from '../controllers/session-provider';
import { ErrorBoundary } from './error-boundary';
import { LoaderFallback } from './loader-fallback';
import { MessagesProvider } from './messages-provider';
export const testIds = {
  linkPickerRoot: 'link-picker-root'
};
export const PACKAGE_DATA: PackageMetaDataType = {
  packageName: process.env._PACKAGE_NAME_ || '',
  packageVersion: process.env._PACKAGE_VERSION_ || '',
  componentName: COMPONENT_NAME,
  source: COMPONENT_NAME
};
const DefaultRootComponent = ({
  children
}: Omit<React.HTMLAttributes<HTMLDivElement>, 'onSubmit'> & LinkPickerProps) => {
  return <div data-testid={testIds.linkPickerRoot}>{children}</div>;
};
const fixedWidthContainerStyles = null;
const FixedWidthContainer = (props: React.HTMLAttributes<HTMLDivElement>) => {
  return <div role="dialog" aria-modal="false" aria-label="link-picker" {...props} className={ax(["_39xV02oEu0"])} />;
};
export const composeLinkPicker = (Component: React.ComponentType<LinkPickerProps>): React.MemoExoticComponent<(props: LinkPickerProps) => JSX.Element> => {
  return memo((props: LinkPickerProps) => {
    const {
      component
    } = props;
    const RootComponent = component ?? DefaultRootComponent;
    return <AnalyticsContext data={PACKAGE_DATA}>
				<LinkPickerSessionProvider>
					<MessagesProvider>
						<div style={{
            [('--link-picker-width' as string)]: props.disableWidth ? '100%' :
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${LINK_PICKER_WIDTH_IN_PX}px`,
            [('--link-picker-padding-left' as string)]: props.paddingLeft ?? "var(--ds-space-200, 16px)",
            [('--link-picker-padding-right' as string)]: props.paddingRight ?? "var(--ds-space-200, 16px)",
            [('--link-picker-padding-top' as string)]: props.paddingTop ?? "var(--ds-space-200, 16px)",
            [('--link-picker-padding-bottom' as string)]: props.paddingBottom ?? "var(--ds-space-200, 16px)"
          }}>
							<FixedWidthContainer>
								<ErrorBoundary>
									<LazySuspense fallback={<LoaderFallback url={props.url} hideDisplayText={props.hideDisplayText} isLoadingPlugins={props.isLoadingPlugins} plugins={props.plugins} />}>
										<RootComponent {...props} data-testid={testIds.linkPickerRoot}>
											<Component {...props} />
										</RootComponent>
									</LazySuspense>
								</ErrorBoundary>
							</FixedWidthContainer>
						</div>
					</MessagesProvider>
				</LinkPickerSessionProvider>
			</AnalyticsContext>;
  });
};